import React from "react";
import LikeOutlineIcon from "../../Icons/LikeOutlineIcon";
import LikeSolidIcon from "../../Icons/LikeSolidIcon";
import PropTypes from "prop-types";
import classNames from "classnames";
import HeartSolid from "../../Icons/HeartSolid";
import HeartOutline from "../../Icons/HeartOutline";
import { motion } from "framer-motion";

const iconMotion = {
  tap: {
    scale: 0,
    transition: {
      type: "spring",
      bounce: 0.2,
      duration: 0.4,
    },
  },
  hover: {
    scale: 1.2,
    transition: {
      type: "spring",
      bounce: 0.2,
      duration: 0.4,
    },
  },
};

export const HelpfulButton = ({
  onHelpful = () => {},
  hasUserVoted = false,
  label = null,
  showLabel = true,
  size = "base",
  showBorders = true,
  iconClass = "",
  variant = "thumbs-up",
  ...props
}) => {
  const normalSizeClass = classNames({
    "px-4.5": showBorders,
  });

  const iconSizeClass = classNames({
    "w-6 h-6": size === "base",
    "w-4 h-4": ["sm", "xs"].includes(size),
  });

  const labelClass = classNames({
    "text-base font-medium text-secondary": size === "base",
    "text-sm font-medium text-secondary": ["sm", "xs"].includes(size),
  });

  const borderClass = classNames({
    "border border-space-60 py-2.5": showBorders,
  });

  const renderIcons = () => {
    switch (variant) {
      case "thumbs-up":
        return hasUserVoted ? (
          <LikeSolidIcon className="w-full h-full" />
        ) : (
          <LikeOutlineIcon className="w-full h-full text-space" />
        );
      case "heart":
        return hasUserVoted ? (
          <HeartSolid className="w-full h-full text-primary" />
        ) : (
          <HeartOutline className="w-full h-full text-space" />
        );
      default:
        return null;
    }
  };

  return (
    <motion.button
      onClick={onHelpful}
      className={`flex items-center space-x-2 text-secondary-dark-200 ${
        showBorders ? "rounded-full hover:bg-light hover:text-secondary" : ""
      } ${normalSizeClass} ${borderClass}`}
      {...props}
      whileHover="hover"
      whileTap="tap"
    >
      <motion.div
        variants={iconMotion}
        className={`${iconSizeClass} ${iconClass}`}
      >
        {renderIcons()}
      </motion.div>
      {showLabel ? (
        <span className={labelClass}>{label || "Helpful"}</span>
      ) : null}
    </motion.button>
  );
};

HelpfulButton.propTypes = {
  /** Function to be called back when button is clicked */
  onHelpful: PropTypes.func.isRequired,
  /** Shows the selected state if true */
  hasUserVoted: PropTypes.bool,
  /** Label to show inside the Button */
  label: PropTypes.string,
  /** Use this bool to show or not show any label */
  showLabel: PropTypes.bool,
  /** This sets the size of the button  */
  size: PropTypes.oneOf(["xs", "sm", "base", "responsive-base"]),
  /** Variant for Icons */
  variant: PropTypes.oneOf(["thumbs-up", "heart"]),
};
